<template>
  <section v-if="homeCourse.length > 0" class="home__section">
    <div class="container">
      <div class="home__title">
        <HomeTitle
          :english="'Optional courses'"
          :title="$t('home.title.courseOverview')"
        />
      </div>

      <div class="home__content course">
        <div class="course__block">
          <router-link
            v-for="item in homeCourse"
            :key="item.courseId"
            class="course__item course__item--transform"
            :to="`/course/classRoom/${ item.courseId }`"
          >
            <div
              class="course__image"
              :style="{ 'background-image': `url(${ item.mainImagePath })` }"
              @mouseenter="
                handlePlayVideo(item)
              "
              @mouseleave="
                handleStopVideo()
              "
            >
              <div
                v-show="isVideoShow"
                v-if="targetId === item.courseId"
                id="playerSmall"
                class="course__player"
              >
                <iframe
                  :ref="`youtubePlayer_${item.courseId}`"
                  :src="
                    `https://www.youtube.com/embed/${ item.courseYoutubeUrl }?rel=0&autoplay=1&mute=1&controls=0&showinfo=0&enablejsapi=1&origin=http%3A%2F%2Fkai-tech.com.tw&widgetid=3`
                  "
                  frameborder="0"
                  allowTransparency="true"
                  allowfullscreen
                />
              </div>
            </div>

            <div class="course__content">
              <p class="course__title">
                <span>{{ item.courseName }}</span>
              </p>

              <p class="course__description">{{ item.courseContent }}</p>

              <p v-if="item.teacherName" class="course__teacher">
                <span>{{ $t('course.label.by') }} {{ item.teacherName }}</span>
              </p>

              <div class="course__info">
                <span v-if="item.totalVideoDuration">
                  {{ $t('course.label.totalDuration') }} {{ item.totalVideoDuration }}{{ $t('course.label.hours') }}
                </span>

                <span class="course__price-origin">
                  NT$ {{ item.courseOriPrice | toCurrency }}
                </span>
              </div>

              <div class="course__price">
                <span v-if="item.buyersCount" class="course__buyersCount">
                  <i class="fa fa-user-plus" />{{ item.buyersCount | toCurrency }}
                </span>

                <span class="course__price-sale">
                  NT$ {{ item.coursePrice | toCurrency }}
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { GetBuyCourseSearchByWonderful } from '@/api/BuyCourseApi';
import HomeTitle from '@/components/HomeTitle.vue';

// /* global $ */
export default {
  components: {
    HomeTitle,
  },
  data() {
    return {
      homeCourse: [],

      targetId: -1,
      playVideoId: -1,
      isVideoShow: false,
    };
  },
  async mounted() {
    await this.GetList();
  },
  methods: {
    GetList() {
      return new Promise((resolve) => {
        GetBuyCourseSearchByWonderful({ courseType: 1 })
          .then((response) => {
            if (response.data.statusCode === 0) {
              this.homeCourse = response.data.data;
            }

            resolve();
          });
      });
    },

    handlePlayVideo(item) {
      if (!item.courseYoutubeUrl) {
        return;
      }

      this.targetId = item.courseId;

      this.$nextTick(() => {
        this.isVideoShow = true;
      });
    },
    async handleStopVideo() {
      this.isVideoShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
